exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".reviews .container{max-width:900px;margin-top:2rem;margin-bottom:4em}.reviews .container .review{margin:2rem 0;min-width:274px}.reviews .container .review .avatar{justify-content:center}@media(min-width: 992px){.reviews .container .review .avatar{justify-content:left}}.reviews .container .review .avatar .rounded-circle{width:82px;margin:1rem 0}.reviews .container .review .avatar .stars{padding:0}.reviews .container .review .avatar .icon-wrapper{border-radius:50%;padding:.8rem;width:80px;height:80px;border:3px solid #cdcdcd}.reviews .container .review .avatar .icon-wrapper .MuiSvgIcon-root{font-size:3rem;color:#cdcdcd}.reviews .container .review h3,.reviews .container .review p{text-align:center}@media(min-width: 992px){.reviews .container .review h3,.reviews .container .review p{text-align:left}}.reviews .container .review p{font-size:1rem;line-height:1.2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/LandingPages/Reviews/Reviews.scss
// module id = 7921
// module chunks = 13